import type { UsageDetail } from '../../services/api';
import { formatCents, formatUsageValue } from '../../services/format';

interface Props {
  rows: UsageDetail[];
  source: 'frozen' | 'live' | 'federated';
}

const SOURCE_LABEL = { frozen: 'eingefroren (Periode abgeschlossen)', live: 'live (laufende Periode)', federated: 'federiert (Enterprise-Target)' };

/** Nutzung vs. im Plan enthaltene Menge, mit Fortschrittsbalken und berechneter Überschreitung. */
export function UsageTable({ rows, source }: Props) {
  return (
    <div>
      <table className="w-full text-sm">
        <thead className="bg-slate-100 text-left">
          <tr>
            <th className="p-2">Metrik</th>
            <th className="p-2">Nutzung / enthalten</th>
            <th className="p-2 w-48">Auslastung</th>
            <th className="p-2 text-right">Überschreitung</th>
            <th className="p-2 text-right">Berechnet</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((u) => {
            const pct = u.included === null ? null : u.included > 0 ? Math.min(100, Math.round((u.used / u.included) * 100)) : (u.used > 0 ? 100 : 0);
            const over = u.included !== null && u.used > u.included;
            return (
              <tr key={u.code} className="border-t">
                <td className="p-2">
                  {u.label}
                  <span className="block text-xs text-slate-400 font-mono">{u.metric}</span>
                </td>
                <td className="p-2 font-mono text-xs">
                  {formatUsageValue(u.metric, u.used)} / {u.included === null ? 'unbegrenzt' : formatUsageValue(u.metric, u.included)}
                </td>
                <td className="p-2">
                  {pct === null ? <span className="text-xs text-slate-400">—</span> : (
                    <div className="h-2 bg-slate-200 rounded" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
                      <div className={`h-2 rounded ${over ? 'bg-red-500' : pct >= 80 ? 'bg-amber-500' : 'bg-green-500'}`} style={{ width: `${pct}%` }} />
                    </div>
                  )}
                </td>
                <td className={`p-2 text-right font-mono ${over ? 'text-red-700' : 'text-slate-400'}`}>{u.overage > 0 ? formatUsageValue(u.metric, u.overage) : '—'}</td>
                <td className="p-2 text-right font-mono">{u.billedCents > 0 ? formatCents(u.billedCents) : '—'}</td>
              </tr>
            );
          })}
          {rows.length === 0 && <tr><td colSpan={5} className="p-3 text-center text-slate-400">Keine nutzungsbasierten Positionen in der Preisliste.</td></tr>}
        </tbody>
      </table>
      <p className="text-xs text-slate-400 mt-1">Datenquelle: {SOURCE_LABEL[source]}.</p>
    </div>
  );
}
